// extracted by mini-css-extract-plugin
module.exports = {"layoutWrap":"LKLayout_layoutWrap__2IU4U","title":"LKLayout_title__3LlA0","content":"LKLayout_content__38s_2","exit":"LKLayout_exit__1QjSv","mobile":"LKLayout_mobile__plmb5"};